import React from 'react'
import Navigation, { NavItem } from 'components/navigation'
import UserInfo from './UserInfo'
import { Authorization } from 'utils'

export default props =>
  <Navigation currentPath={props.currentPath} userInfo={<UserInfo/>}>
    <NavItem title="nav.deals" link="/" match="/deal_sheets" requires={Authorization.admin}>
      <NavItem title="nav.deals.manage" link="/deal_sheets_admin" requires={Authorization.admin} match="/deal_sheets_admin" />
      <NavItem title="nav.deals.dashboard" link="/dashboard" match="/deal_sheets/\d+|/dashboard" />
      <NavItem title="nav.deals.active" link="/deal_sheets/list/active" requires={!Authorization.admin}/>
      <NavItem title="nav.deals.past" link="/deal_sheets/list/past" requires={Authorization.admin} />
      <NavItem title="nav.deals.featured" link="/deal_sheets/featured" requires={Authorization.admin}/>
    </NavItem>
    <NavItem title="nav.allocations" link="/allocations" requires={Authorization.admin}/>
    <NavItem title="nav.admin" link="/users" requires={Authorization.admin} >
      <NavItem title="nav.admin.users" link="/users" match="/users|/investor|/issuer"/>
      <NavItem title="nav.admin.third_parties" link="/third_parties"/>
      <NavItem title="nav.admin.countries" link="/countries"/>
      <NavItem title="nav.admin.legal_docs" link="/documents/edit"/>
      <NavItem title="nav.admin.audit_logs" link="/audit_logs"/>
    </NavItem>
    <NavItem title="nav.deals.dashboard" link="/" match="/deal_sheets" requires={Authorization.registered && !Authorization.admin} />
  </Navigation>

